import * as React from 'react';
import './Loading.css';
import { Panel } from 'react-bootstrap';
import { BadgeLoadingIndicator } from "./BadgeLoadingIndicator";

interface LoadingIndicatorProps {
    showBackground?: boolean;
    showInPanel?: boolean;
    showPdfDescription?: boolean;
}

export class LoadingIndicator extends React.Component<LoadingIndicatorProps> {

    render() {
        if (this.props.children) {
            return <div className="loading">
                <div className="shimmer-loading-container">
                    {this.props.children}
                </div>
            </div>;
        }

        let component = <BadgeLoadingIndicator />;

        if (this.props.showPdfDescription === true) {
            component = (
                <>
                    <div className="modal-badge-container">
                        {component}
                    </div>
                    <div className="loading-text">Creating report</div>
                </>
            );
        }

        if (this.props.showInPanel === true) {
            component = (
                <Panel className="loading-panel">
                    <Panel.Body className="loading-panel-body">
                        {component}
                    </Panel.Body>
                </Panel>
            );
        }
        
        if (this.props.showBackground === true) {
            return (
                <div className="loading-container badge-loading-container with-background">
                    {component}
                </div>);
        } else {
            return (
                <div className="loading-container badge-loading-container">
                    {component}
                </div>);
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/loadingIndicator/LoadingIndicator.tsx